export default __webpack_public_path__ + "static/media/slider2.06e6d334.png";